module.exports = __webpack_public_path__ + "static/status_needpay.9a65c1a1.png";